<header>
  <h2>Colaborador AXA</h2>
  <span style="flex: 1 1 auto;"></span>
  <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
</header>
<mat-dialog-content style="padding-bottom: 0;">
  <form [formGroup]="busquedaForm" (ngSubmit)="buscar()">
    <fieldset class="campo" [disabled]="buscando">
      <legend style="margin-bottom: 5px;">Buscar por</legend>
      <mat-select formControlName="tipo">
        <mat-option [value]="TipoBusqueda.Poblacion">Población</mat-option>
        <mat-option [value]="TipoBusqueda.Provincia">Provincia</mat-option>
        <mat-option [value]="TipoBusqueda.CodigoPostal">Código postal</mat-option>
      </mat-select>
      <div>
        <input
            type="search"
            matInput
            formControlName="valor"
            (dblclick)="resetBusquedaForm()"
            >
            <mat-progress-bar *ngIf="buscando" mode="indeterminate" />
      </div>
        <button style="margin-right: 4px; width: 20%;" type="submit" mat-flat-button class="btnCCNewOscuro" [disabled]="!busquedaForm.valid">Buscar</button>
    </fieldset>
  </form>

  <!--<form id="axa" [formGroup]="axaForm" (ngSubmit)="guardar()">
    <fieldset [disabled]="guardando">
      <label>
        Num. colabora.<br>
        <input type="text" required matInput formControlName="numeroColaborador"><br>
      </label>

      <label>
        Nom. colabora.<br>
        <input type="text" required matInput formControlName="nombreColaborador"><br>
      </label>

      <label>
        Direc. colabora.<br>
        <input type="text" required matInput formControlName="direccionColaborador"><br>
      </label>

      <label>
        Tel. colabora.<br>
        <input type="tel" required matInput formControlName="telefonoColaborador" style="width: 98%"><br>
      </label>

      <label>
        Nombre cliente<br>
        <input type="text" required matInput formControlName="nombreCliente" style="width: 99%"><br>
      </label>

      <label>
        Teléfono<br>
        <input type="tel" required matInput formControlName="telefonoCliente"><br>
      </label>

      <label>
        Matrícula<br>
        <input type="text" required matInput formControlName="matricula"><br>
      </label>

      <label>
        NIF<br>
        <input type="text" matInput formControlName="nif" style="width: 98%"><br>
      </label>

      <label>
        Póliza<br>
        <input type="text" matInput formControlName="poliza"><br>
      </label>
      <label>
        Cristal<br>
        <mat-select formControlName="cristal"  class="selectorCristal">
          <mat-option *ngFor="let c of cristales" [value]="c" >{{ c }}</mat-option>
        </mat-select>
      </label>

      <label>
        Observaciones<br>
        <textarea type="text" rows="6" matInput formControlName="observaciones" style="width: 99.6%"></textarea><br>
      </label>
    </fieldset>
  </form>-->

  <form id="axa" [formGroup]="axaForm" (ngSubmit)="guardar()">
    <div style="display: flex;gap: 10px;margin-top:10px; width:99.7%;">
      <div class="campo">
        <label>Num. colabora.</label>
        <input type="text" required matInput formControlName="numeroColaborador"><br>
      </div>
      <div class="campo">
        <label>Nom. colabora.</label>
        <input type="text" required matInput formControlName="nombreColaborador"><br>
      </div>
      <div class="campo">
        <label>Direc. colabora.</label>
        <input type="text" required matInput formControlName="direccionColaborador"><br>
      </div>
      <div class="campo">
        <label>Tel. colabora.</label>
        <input type="tel" required matInput formControlName="telefonoColaborador" style="width: 98%"><br>
      </div>
    </div>
    <div style="display: flex;gap: 10px;margin-top:10px; width:99.7%;">
      <div class="campo">
        <label>Nombre cliente</label>
        <input type="text" required matInput formControlName="nombreCliente" style="width: 99%"><br>
      </div>
      <div class="campo">
        <label>Teléfono</label>
        <input type="tel" required matInput formControlName="telefonoCliente"><br>
      </div>
      <div class="campo">
        <label>Matrícula</label>
        <input type="text" required matInput formControlName="matricula"><br>
      </div>
      <div class="campo">
        <label>NIF</label>
        <input type="text" matInput formControlName="nif" style="width: 98%"><br>
      </div>
    </div>
    <div style="display: flex;gap: 10px;margin-top:10px; width:99.7%;">
      <div class="campo">
        <label>Póliza</label>
        <input type="text" matInput formControlName="poliza"><br>
      </div>
      <div class="campo">
        <label>Cristal</label>
        <mat-select formControlName="cristal" style="height: 32px;">
          <mat-option *ngFor="let c of cristales" [value]="c" style="color: #093a33">{{ c }}</mat-option>
        </mat-select>
      </div>
    </div>
    <div style="display: flex;gap: 10px;margin-top:10px; width:99.7%;">
      <div class="campo">
        <label>Observaciones</label>
        <textarea type="text" matInput formControlName="observaciones" style="width: 100%"></textarea><br>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-progress-bar *ngIf="guardando" mode="indeterminate"></mat-progress-bar>
<mat-dialog-actions align="center" style="margin-bottom: 20px; margin-top:10px;">
  <button style="width: 15%;" type="button" class="btnCCOscuro" mat-flat-button [mat-dialog-close]="true" [disabled]="guardando">Cancelar</button>
  <button style="width: 15%;" type="submit" class="btnCCNewOscuro" mat-flat-button form="axa">Guardar</button>
</mat-dialog-actions>
